import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';
import moment from 'moment';

const Transactions = observer(class Transactions extends React.Component {
  componentWillMount() {
    this.props.store.UserStore.getTransactions();
  }

  highlight(amount, highlightPositive) {
    if(amount < 0) {
      return 'negative';
    } else if(amount > 0 && highlightPositive) {
      return 'positive';
    }

    return '';
  }

  renderResults() {
    const { translation, store } = this.props;
    const { transactions } = store.UserStore;

    if(transactions.length > 0) {
      return (
        <div>
          <table className="panel">
            <thead className="panel__header">
              <tr>
                <th className="subtitle" scope="col">{translation.date}</th>
                <th className="subtitle" scope="col">{translation.description}</th>
                <th className="subtitle" scope="col">{translation.transaction_id}</th>
                <th className="subtitle number" scope="col">{translation.amount}</th>
              </tr>
            </thead>
            <tbody className="panel__body">
              {transactions.map(
                (key, i) => {
                  if(key.status.toLowerCase() !== 'deferred') {
                    return (
                      <tr key={i}>
                        <td>
                          {moment(key.createdDate).tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}
                        </td>
                        <td>{key.description}</td>
                        <td>{key.processorTransactionId}</td>
                        <td className={`number ${this.highlight(key.amount, false)}`}>
                          {currencyFormatter.format(key.amount, {code: key.currency})} {key.currency}
                        </td>
                      </tr>
                    )
                  } else {
                    return null;
                  }
                }
              )}
            </tbody>
          </table>

          {/* <h4 className="total">{translation.current_balance}: <strong className="success">$14.95</strong></h4> */}
        </div>
      )
    } else {
      return <span className="no-results">{translation.no_results}</span>
    }
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    if(!SessionStore.loading) {
      return(
        <main tabIndex="0" id="main-content" className="page">
          <header className="page__header">
            <div className="wrap">
              <h1 className="page__title">{translation.page_title}</h1>
            </div>
          </header>

          <div className="wrap">
            {this.renderResults()}
          </div>
        </main>
      );
    }

    return null;
  }
})

export default translate('Transactions')(Transactions);


// WEBPACK FOOTER //
// ./src/app/components/Account/Transactions.js